var _path, _path2, _line, _line2, _line3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideBurgerRecognition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5078 14.2675C14.0213 14.4601 15.626 15.0378 17.1666 15.0378C18.7071 15.0378 20.1192 14.3959 20.8253 13.8824C21.1334 13.7283 21.5314 13.3047 21.5956 13.3047",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7829 5.98687C17.7457 6.372 18.7086 5.98687 18.7086 5.98687M18.7086 5.98687C18.7086 5.98687 20.2491 5.60174 20.2491 4.44635C20.2491 2.90582 19.4788 2.32812 16.9755 2.32812C14.6647 2.32812 13.5093 2.98127 13.5093 4.44635C13.5093 5.52472 14.5363 6.05106 15.0498 6.17944V9.64562C15.0498 10.6084 13.7252 11.2425 13.3167 11.3787C12.739 11.5713 11.9688 12.149 11.9688 12.9192C11.9688 13.5354 11.9688 14.8449 11.9688 15.4226C12.1613 16.1287 13.3937 17.5408 16.7829 17.5408C20.172 17.5408 21.4045 16.1287 21.597 15.4226V12.9192C21.597 12.4699 21.597 11.7638 20.8268 11.3787C19.8993 10.915 18.516 10.6084 18.516 9.83819C18.516 9.22198 18.6508 7.07808 18.7086 5.98687Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.24,
    y1: 8.24047,
    x2: 11.9221,
    y2: 8.24047,
    stroke: "white",
    strokeWidth: 0.48,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.85328,
    y1: 9.77953,
    x2: 11.5354,
    y2: 9.77953,
    stroke: "white",
    strokeWidth: 0.48,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5.47047,
    y1: 11.3225,
    x2: 9.22691,
    y2: 11.3225,
    stroke: "white",
    strokeWidth: 0.48,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9819 19.2601L22.5595 21.5709H0.992188L4.8435 6.55078H12.161",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBurgerRecognition);
export default __webpack_public_path__ + "static/media/SideBurgerRecognition.d458d36090200c8338ebb4a5e013b0dc.svg";
export { ForwardRef as ReactComponent };